import { useHistory } from 'react-router-dom';
import pages from '../routes/pages';
import { ID } from '../types/typeDef';
import { getGoToPage } from '../helpers/page/goToPage';

export const useToCommandePages = () => {
  const history = useHistory();
  const toCommandeSinglePage = getGoToPage<{ id: string }>(history)(
    pages.COMMANDE_SINGLE_PAGE.path
  );
  const toCommandeUpdatePage = getGoToPage<{ id: string }>(history)(
    pages.UPDATE_COMMANDE_PAGE.path
  );
  return [
    (id: ID) => toCommandeSinglePage({ id }),
    (id: ID) => toCommandeUpdatePage({ id })
  ];
};
